import t from '../translation';
import prefill from './prefill';

export default prefill({
  baseHair1: { setPrice: 5, text: t('hairSet1') },
  baseHair2: { setPrice: 5, text: t('hairSet2') },
  baseHair3: { setPrice: 5, text: t('hairSet3') },
  facialHair: { setPrice: 5, text: t('titleFacialHair') },
  specialShirts: { setPrice: 5, text: t('specialShirts') },
  legacyShirts: { },
  winterHairColors: { setPrice: 5 },
  pastelHairColors: { setPrice: 5 },
  rainbowHairColors: { setPrice: 5, text: t('rainbowColors') },
  shimmerHairColors: { setPrice: 5, text: t('shimmerColors') },
  summerHairColors: { setPrice: 5, text: t('summerColors') },
  hauntedHairColors: { setPrice: 5, text: t('hauntedColors') },
  winteryHairColors: { setPrice: 5, text: t('winteryColors') },
  rainbowSkins: { setPrice: 5, text: t('rainbowSkins') },
  animalSkins: { setPrice: 5, text: t('animalSkins') },
  pastelSkins: { setPrice: 5, text: t('pastelSkins') },
  spookySkins: { setPrice: 5, text: t('spookySkins') },
  supernaturalSkins: { setPrice: 5, text: t('supernaturalSkins') },
  splashySkins: { setPrice: 5, text: t('splashySkins') },
  winterySkins: { setPrice: 5, text: t('winterySkins') },
});
